/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface BillPayee
 */
export interface BillPayee {
    /**
     * 
     * @type {string}
     * @memberof BillPayee
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BillPayee
     */
    'bankCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillPayee
     */
    'bankName': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillPayee
     */
    'branchCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillPayee
     */
    'branchName': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillPayee
     */
    'accountType': BillPayeeAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BillPayee
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof BillPayee
     */
    'accountHolder': string;
    /**
     * 
     * @type {boolean}
     * @memberof BillPayee
     */
    'isSaved': boolean;
}

export const BillPayeeAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    depositAccount: 'DEPOSIT_ACCOUNT',
    otherAccount: 'OTHER_ACCOUNT'
} as const;

export type BillPayeeAccountTypeEnum = typeof BillPayeeAccountTypeEnum[keyof typeof BillPayeeAccountTypeEnum];


